import { useState } from "react";
import { Button, TextField } from "@mui/material";

export interface LinkUrlPreviewProps {
    linkUrl: string;
}

export default function LinkUrlPreview({ linkUrl }: LinkUrlPreviewProps) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(linkUrl);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1500);
        } catch {
            /* tolerate */
        }
    };

    return (
        <div className="integration-link-url-preview">
            <div className="integration-link-url-preview__header">
                <span className="integration-link-url-preview__title">Shareable link</span>
                <div className="integration-link-url-preview__actions">
                    <Button size="small" onClick={handleCopy}>
                        {copied ? "Copied" : "Copy"}
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        onClick={() => window.open(linkUrl, "_blank", "noopener,noreferrer")}
                    >
                        Open
                    </Button>
                </div>
            </div>
            <TextField
                fullWidth
                value={linkUrl}
                InputProps={{ readOnly: true }}
                inputProps={{ style: { fontFamily: "monospace", fontSize: 12 } }}
            />
        </div>
    );
}
